import type { Team } from "@redotech/redo-model/team";
import type { Product } from "../registry/types";
import { isProductEnabledForTeam } from "./is-product-enabled";

/**
 * Whether `?setupSource=...` should trigger a new merchant_setup_progress
 * row insert for this team + product. Pure function so the rule is testable
 * without rendering the provider.
 *
 * Rules:
 *   - If a row already exists, no insert (the entry source is recorded on
 *     the existing row's audit trail; row insert is idempotent at the DB).
 *   - If no row exists AND the team is already on the legacy flow
 *     (`team.settings.<product>.enabled === true`), skip insert. Stale
 *     email links shouldn't drag legacy merchants into the new system.
 *   - Otherwise the merchant is genuinely fresh — create the row.
 */
export function shouldCreateRowFromEntrySource(args: {
  team: Team;
  product: Product;
  hasExistingRow: boolean;
}): boolean {
  if (args.hasExistingRow) {
    return false;
  }
  if (isProductEnabledForTeam(args.product, args.team)) {
    return false;
  }
  return true;
}
